import { ELightPath } from "../Model/CaptureProfile";

class LightPathUtil {
  static toAbbreviation(lightpath: ELightPath): string {
    switch (lightpath) {
      case ELightPath.Visible:
        return "Vis";
      case ELightPath.Ultraviolet:
        return "UV";
      case ELightPath.Sonicc:
        return "Son";
      case ELightPath.Frap:
        return "Fr";
      case ELightPath.Fluorescence:
        return "Mfi";
      default:
        return "ERROR";
    }
  }

  static toName(lightpath: ELightPath | number | string): string {
    switch (lightpath) {
      case ELightPath.Visible:
      case 0:
      case "0":
      case "Visible":
      case "visible":
        return "Visible";
      case ELightPath.Ultraviolet:
      case 1:
      case "1":
      case "Ultraviolet":
      case "ultraviolet":
        return "Ultraviolet";
      case ELightPath.Sonicc:
      case 2:
      case "2":
      case "Sonicc":
      case "sonicc":
        return "Sonicc";
      case ELightPath.Frap:
      case 3:
      case "3":
      case "Frap":
      case "frap":
        return "Frap";
      case ELightPath.Fluorescence:
      case 4:
      case "4":
      case "Fluorescence":
      case "fluorescence":
        return "Fluorescence";
      default:
        return "";
    }
  }

  static toField(lightpath: ELightPath): string {
    switch (lightpath) {
      case ELightPath.Visible:
        return "visible";
      case ELightPath.Ultraviolet:
        return "ultraviolet";
      case ELightPath.Sonicc:
        return "sonicc";
      case ELightPath.Frap:
        return "frap";
      case ELightPath.Fluorescence:
        return "fluorescence";
      default:
        return "";
    }
  }
}

export default LightPathUtil;
